<template>
  <VueVideoThumbnail :video-src="src" :snapshot-at-duration-percent="1" :width="500" :height="300" :chunks-quantity="10">
    <template #snapshot="{ snapshot }">
      <img v-if="snapshot" :src="snapshot" alt="snapshot" />
    </template>
  </VueVideoThumbnail>
</template>
<script>
import VueVideoThumbnail from 'vue-video-thumbnail'
import './k2Video.scss'

export default {
  name: 'K2Video',
  components: {
    VueVideoThumbnail,
  },
  props: ['src'],
}
</script>
